(function (window, document) {
  'use strict';

  var formSelector = [
    'form.product-item__quick-form',
    '[data-globo-filter-items] form[action*="/cart/add"]',
    '#gf-products form[action*="/cart/add"]',
    '.gf-products form[action*="/cart/add"]'
  ].join(', ');
  var collectionRootSelector = [
    '[data-globo-filter-items]',
    '#gf-products',
    '.gf-products',
    '.collection-grid__wrapper',
    '.grid-product',
    '.product-item',
    '.product-card'
  ].join(', ');
  var pendingForms = new WeakSet();
  var pendingLinks = new WeakSet();
  var boundForms = new WeakSet();

  function getSubmitButton(form) {
    return form.querySelector('.add-to-cart, [type="submit"]');
  }

  function serialize(form) {
    if (window.theme && window.theme.utils && typeof window.theme.utils.serialize === 'function') {
      return window.theme.utils.serialize(form);
    }

    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      params.append(key, value);
    });
    return params.toString();
  }

  function showError(form, message) {
    var previous = form.querySelector('.errors');
    if (previous && previous.remove) previous.remove();

    var error = document.createElement('div');
    error.className = 'errors text-center';
    error.textContent = message;
    form.append(error);
  }

  function notifyAdded(product, button) {
    document.dispatchEvent(new CustomEvent('globo.preorder.update.cart'));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: {product: product, addToCartBtn: button}
    }));
  }

  window.KMCartDrawerProductBridge = window.KMCartDrawerProductBridge || {};
  window.KMCartDrawerProductBridge.notifyAdded = notifyAdded;

  function addToCart(form) {
    var button = getSubmitButton(form);
    var theme = window.theme || {};
    var routes = theme.routes || {};
    var finishOperation = function () {};
    var operationSucceeded = false;

    if (theme.cart && typeof theme.cart.beginAddOperation === 'function') {
      finishOperation = theme.cart.beginAddOperation('product-add') || finishOperation;
    }

    if (button) {
      button.disabled = true;
      button.classList.add('btn--loading');
      button.setAttribute('aria-busy', 'true');
    }

    return fetch(routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      body: serialize(form),
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Unable to add this item. Please try again.');
          }
          return data;
        });
      })
      .then(function (product) {
        window.KMCartDrawerProductBridge.notifyAdded(product, button);
        operationSucceeded = true;
        return product;
      })
      .catch(function (error) {
        showError(form, error.message || 'Unable to add this item. Please try again.');
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: {errorMessage: error.message}
        }));
        throw error;
      })
      .finally(function () {
        finishOperation(operationSucceeded);
        pendingForms.delete(form);
        if (button) {
          button.disabled = false;
          button.classList.remove('btn--loading');
          button.setAttribute('aria-busy', 'false');
        }
      });
  }

  function isCollectionForm(form) {
    if (!form || !form.matches) return false;
    if (form.matches(formSelector)) return true;

    return form.matches('form[action*="/cart/add"]') &&
      !!(form.closest && form.closest(collectionRootSelector));
  }

  function formFromTarget(target) {
    if (!target) return null;
    var form = target.form || (target.closest && target.closest('form'));
    return isCollectionForm(form) ? form : null;
  }

  function getAddLink(target) {
    var link = target && target.closest && target.closest('a[href]');
    if (!link || !link.getAttribute) return null;
    if (!(link.closest && link.closest(collectionRootSelector))) return null;

    var href = link.getAttribute('href');
    if (!href) return null;

    var parsed;
    try {
      parsed = new URL(href, (window.location && window.location.origin) || 'http://localhost');
    } catch (error) {
      return null;
    }

    if (!/(?:^|\/)cart\/add(?:\.js)?\/?$/.test(parsed.pathname) || !parsed.searchParams.get('id')) {
      return null;
    }

    return {link: link, params: parsed.searchParams};
  }

  function addFromLink(addLink) {
    var link = addLink.link;
    var params = addLink.params;
    var theme = window.theme || {};
    var routes = theme.routes || {};
    var finishOperation = function () {};
    var operationSucceeded = false;

    if (pendingLinks.has(link)) return Promise.resolve();
    pendingLinks.add(link);

    if (!params.get('quantity')) params.set('quantity', '1');
    if (theme.cart && typeof theme.cart.beginAddOperation === 'function') {
      finishOperation = theme.cart.beginAddOperation('product-add') || finishOperation;
    }

    link.classList && link.classList.add('btn--loading');
    if (link.setAttribute) link.setAttribute('aria-busy', 'true');

    return fetch(routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      body: params.toString(),
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Unable to add this item. Please try again.');
          }
          return data;
        });
      })
      .then(function (product) {
        notifyAdded(product, link);
        operationSucceeded = true;
        return product;
      })
      .catch(function (error) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: {errorMessage: error.message}
        }));
        throw error;
      })
      .finally(function () {
        finishOperation(operationSucceeded);
        pendingLinks.delete(link);
        if (link.classList) link.classList.remove('btn--loading');
        if (link.setAttribute) link.setAttribute('aria-busy', 'false');
      });
  }

  function intercept(event, form) {
    if (!isCollectionForm(form)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (pendingForms.has(form)) return;

    pendingForms.add(form);
    return addToCart(form).catch(function () {});
  }

  function isAddControl(button) {
    if (!button) return true;
    var type = String(button.type || '').toLowerCase();
    if (type && type !== 'submit') {
      return !!(button.matches && button.matches('.add-to-cart, .gf_add_to_cart, .gf-add-to-cart, [data-add-to-cart], [data-cart-add], [data-product-add]'));
    }
    return true;
  }

  function bindForm(form) {
    if (!isCollectionForm(form) || !form.addEventListener || boundForms.has(form)) return;
    boundForms.add(form);

    form.addEventListener('click', function (event) {
      var target = event.target;
      var addLink = getAddLink(target);
      if (addLink) {
        event.preventDefault();
        event.stopImmediatePropagation();
        addFromLink(addLink).catch(function () {});
        return;
      }

      // Globo's standard quick-add form contains only the add action. Bind the
      // form itself as a fallback because the app can submit before delegated
      // document handlers receive the click.
      if (form.matches('form.product-item__quick-form')) {
        intercept(event, form);
        return;
      }

      var control = target && target.closest && target.closest(
        '.add-to-cart, [type="submit"], button[is="loader-button"], button:not([type="button"]), .gf_add_to_cart, .gf-add-to-cart, [data-add-to-cart], [data-cart-add], [data-product-add]'
      );
      if (control && !isAddControl(control)) return;
      if (!control && target !== form) return;

      intercept(event, form);
    }, true);
  }

  function bindForms(root) {
    var selector = formSelector;
    if (!root) return;

    if (root.matches && root.matches(selector)) bindForm(root);
    if (!root.querySelectorAll) return;

    root.querySelectorAll(selector).forEach(bindForm);
  }

  function startDirectFormBinding() {
    bindForms(document);

    if (typeof MutationObserver === 'function' && document.documentElement) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes') {
            bindForms(mutation.target);
            return;
          }
          Array.prototype.forEach.call(mutation.addedNodes || [], bindForms);
        });
      });
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'action']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startDirectFormBinding, {once: true});
  } else {
    startDirectFormBinding();
  }

  window.KMCartDrawerProductBridge.refreshCollectionForms = function () {
    bindForms(document);
  };

  document.addEventListener('click', function (event) {
    var target = event.target;
    var button = target && target.closest && target.closest('.add-to-cart, [type="submit"], button[is="loader-button"], button:not([type="button"]), .gf_add_to_cart, .gf-add-to-cart, [data-add-to-cart], [data-cart-add], [data-product-add]');
    var form = formFromTarget(button || target);

    if (form && isAddControl(button)) {
      intercept(event, form);
      return;
    }

    var addLink = getAddLink(target);
    if (addLink) {
      event.preventDefault();
      event.stopImmediatePropagation();
      addFromLink(addLink).catch(function () {});
    }
  }, true);

  document.addEventListener('submit', function (event) {
    return intercept(event, event.target);
  }, true);
})(window, document);
